import { type ModuleManifest } from '@/lib/modules/types'

export const manifest: ModuleManifest = {
  module_id: 'cockpit',
  display_name: 'Cockpit',
  surface: 'admin',
  routes: [
    {
      path: '/cockpit',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitHomePage,
        })),
      title: 'Cockpit',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariDomainPage,
        })),
      title: 'Cockpit - Cuidari',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/product',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariProductPage,
        })),
      title: 'Cockpit - Cuidari Produto',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/overview',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainOverviewPage,
        })),
      title: 'Cockpit - Domain Overview',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/users',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariUsersPage,
        })),
      title: 'Cockpit - Cuidari Usuarios',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/users',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainUsersPage,
        })),
      title: 'Cockpit - Domain Users',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/growth-graph',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariGrowthGraphPage,
        })),
      title: 'Cockpit - Cuidari Growth Graph',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/growth',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainGrowthPage,
        })),
      title: 'Cockpit - Domain Growth',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/cohorts',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariCohortsPage,
        })),
      title: 'Cockpit - Cuidari Cohorts',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/cohorts',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainCohortsPage,
        })),
      title: 'Cockpit - Domain Cohorts',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/surfaces',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainSurfacesPage,
        })),
      title: 'Cockpit - Domain Surfaces',
      permissions: [],
    },
    {
      path: '/cockpit/domains/$domainSlug/quality',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitDomainQualityPage,
        })),
      title: 'Cockpit - Domain Quality',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/users/$userId',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitUserPage,
        })),
      title: 'Cockpit - Cuidari User 360',
      permissions: [],
    },
    {
      path: '/cockpit/cuidari/surfaces/$surfaceId',
      validateSearch: (raw: Record<string, unknown>) => ({
        userId: typeof raw.userId === 'string' ? raw.userId : undefined,
      }),
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitCuidariSurfacePage,
        })),
      title: 'Cockpit - Superficie Cuidari',
      permissions: [],
    },
    {
      path: '/cockpit/groups/$groupId',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitGroupPage,
        })),
      title: 'Cockpit - Funcao',
      permissions: [],
    },
    {
      path: '/cockpit/flows/$flowId',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitFlowPage,
        })),
      title: 'Cockpit - Fluxo',
      permissions: [],
    },
    {
      path: '/cockpit/users/$userId',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitUserPage,
        })),
      title: 'Cockpit - User 360',
      permissions: [],
    },
    {
      path: '/cockpit/systems',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitSystemsPage,
        })),
      title: 'Cockpit - Catalogo tecnico',
      permissions: [],
    },
    {
      // G0.6 — Proteus freshness dashboard.
      //
      // Lives outside `/cockpit/systems/$systemId` to avoid colliding
      // with the catch-all system-detail route. Wired from the Proteus
      // system page via a `Freshness 24h` button. Alarm definition is
      // in `cdk/observability/proteus_freshness_construct.py`.
      path: '/cockpit/proteus/freshness',
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitProteusFreshnessPage,
        })),
      title: 'Cockpit - Proteus Freshness',
      permissions: [],
    },
    {
      path: '/cockpit/systems/$systemId',
      validateSearch: (raw: Record<string, unknown>) => ({
        surfaceId: typeof raw.surfaceId === 'string' ? raw.surfaceId : undefined,
      }),
      component: () =>
        import('@/routes/_app/cockpit').then((m) => ({
          default: m.CockpitSystemPage,
        })),
      title: 'Cockpit - Sistema',
      permissions: [],
    },
  ],
}
